import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Errors } from 'react-redux-form';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import DateTime from 'react-datetime';
import moment from 'moment';
import PropTypes from 'prop-types';

class RequiredDatePicker extends Component {
  constructor(props) {
    //let value = moment().format('DD/MM/YYYY');
    super(props);

    this.state = {
      value: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value === '') {
      this.setState({
        value: ''
      });
    }
    if (nextProps.value && this.state.value !== nextProps.value) {
      const value = moment(nextProps.value);
      this.setState({value: value }, () => {
        if (value) {

          this.props.dispatch(actions.change(this.props.model, value.format()));

          this.props.dispatch(
            actions.setErrors(this.props.model, { required: false })
          );
        }

      });

    }
  }

  componentWillMount() {
    const { model, dispatch } = this.props;
    dispatch(actions.setValidity(model, false));
  }

  componentDidMount() {
    const { value, model, dispatch } = this.props;
    if (this.state.value === '') {
      this.componentWillReceiveProps({ value: value });
    }
    dispatch(actions.change(model, this.state.value));
  }

  handleChange = (value, formattedValue) => {
    const { model, dispatch } = this.props;

    if (typeof value === 'object') {
      this.setState({
        value: value
      });
      dispatch(actions.change(model, value.format()));
      dispatch(actions.setValidity(model, { required: true }));
    } else {
      this.setState({
        value: ''
      });
      dispatch(actions.change(model, ''));
      dispatch(actions.setValidity(model, { required: false }));
    }
  };

  render() {
    return (
      <FormGroup
        className="ignite-datepicker"
        controlId={this.props.controlId}
        validationState={this.state.value ? null : 'error'}
      >
        {this.props.label && <ControlLabel>{this.props.label}*</ControlLabel>}
        <DateTime
          timeFormat={this.props.timeFormat}
          dateFormat={this.props.dateFormat}
          className={this.props.classNames}
          inputProps={{
            disabled: this.props.disabled,
            placeholder: this.props.placeholder
          }}
          closeOnSelect={!this.props.timeFormat}
          value={this.state.value}
          onChange={this.handleChange}
        />

        <Errors
          show={this.state.value ? true : false}
          className="errors"
          model={this.props.model}
          messages={{ required: 'This field is required' }}
        />
      </FormGroup>
    );
  }
}

RequiredDatePicker.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  controlId: PropTypes.string,
  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  timeFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.any
};

RequiredDatePicker.defaultProps = {
  controlId: Math.random()
    .toString(16)
    .substring(2),
  dateFormat: 'DD/MM/YYYY',
  timeFormat: false
};

export default connect()(RequiredDatePicker);



// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-datepicker.jsx